export const ESCAPE_KEY = 27;
export const TAB_KEY = 9;
export const ENTER_KEY = 13;
export const HC_UTM_PARAMS =
  'utm_source=buffer&utm_medium=learn-more-link&utm_campaign=learn-more';
